import { combineReducers } from "redux"

import update from "./update/slice"

const settingsReducer = combineReducers({
  update,
})

export default settingsReducer
